import React from "react";
import Quiz from "../Quiz";

const questions = [
  // Algebra section
  {
    questionText: "The coefficient of the variable in x² + 4 is:",
    options: ["0", "1", "2", "4"],
    correct: "1",
  },
  {
    questionText: "In the expression x² − 4x − 1/3, the constant term is:",
    options: ["1/3", "-1/3", "-4", "2/3"],
    correct: "-1/3",
  },
  {
    questionText: "The value of (5x − 1)^0 is:",
    options: ["0", "1", "4", "5"],
    correct: "1",
  },
  {
    questionText: "Algebraic expression for: The product of a number and 5 is increased by 2:",
    options: ["2 × 5 + m", "5 + 2 × m", "2m + 5", "5m + 2"],
    correct: "5m + 2",
  },
  {
    questionText: "What does the expression −3y + 2 represent?",
    options: [
      "A number is added to negative 3 then 2 is added.",
      "A number is subtracted from 3 then 2 is added.",
      "A number is multiplied by negative 3 then 2 is added to the product.",
      "A number is multiplied by 3 then 2 is subtracted from the product.",
    ],
    correct: "A number is multiplied by negative 3 then 2 is added to the product.",
  },
  {
    questionText: "What is the coefficient of x² in −13x² + 7xy?",
    options: ["-6", "2", "7", "-13"],
    correct: "-13",
  },
  {
    questionText: "Simplify: -2p + 6p",
    options: ["-8p", "4p", "4p²", "8p²"],
    correct: "4p",
  },
  {
    questionText: "How many terms are in 2x(y + y)?",
    options: ["1", "2", "3", "4"],
    correct: "1",
  },
  {
    questionText: "Simplify: y − y − y",
    options: ["3y", "-y", "-3y", "(-y)³"],
    correct: "-3y",
  },
  {
    questionText: "What is 2x subtracted from 2y?",
    options: ["2x − 2y", "2 − y", "2y − 2x", "y − x"],
    correct: "2y − 2x",
  },
  {
    questionText: "Which is an equation?",
    options: [
      "2 + 3 − 3 = 7 − 2",
      "2 + 3 = 7 − 2",
      "2 + 3 + 5 = 7 − 2",
      "2 + 3 − 1 = 7 − 2",
    ],
    correct: "2 + 3 − 3 = 7 − 2",
  },
  {
    questionText: "Find the missing number: 22 + 35 = 63 − □",
    options: ["6", "28", "41", "57"],
    correct: "6",
  },
  {
    questionText: "Expression for learners in 7 classes with 36 learners each?",
    options: [
      "36 ÷ 7",
      "36 × 7",
      "36 + 7",
      "36 − 7",
    ],
    correct: "36 × 7",
  },
  {
    questionText: "Which number sentence is correct?",
    options: [
      "14 × 1 + 0 = 0",
      "14 × 0 + 1 = 0",
      "15 + 4 × 5 = 35",
      "(15 + 4) × 5 = 95",
    ],
    correct: "(15 + 4) × 5 = 95",
  },
  {
    questionText: "Why is 8 + 2 + 3 = 4 – 9 incorrect?",
    options: [
      "2 is added to 8, should be subtracted",
      "3 is added to 8, should be subtracted",
      "9 is added to 4, should be subtracted",
      "9 is subtracted from 4, should be added",
    ],
    correct: "9 is subtracted from 4, should be added",
  },
  {
    questionText: "Which number sentences are true?",
    options: [
      "Only 1 is true",
      "Only 3 is true",
      "1 and 3 are true",
      "2 and 4 are true",
    ],
    correct: "1 and 3 are true",
  },
  {
    questionText: "Solve: 2 × □ + 6 = 16",
    options: ["2", "5", "20", "11"],
    correct: "5",
  },
  {
    questionText: "Solve: □ – 4 = +4 / 2",
    options: ["0", "-16", "-6", "-4"],
    correct: "0",
  },
  {
    questionText: "Solve: 3^t = 1. What is t?",
    options: ["t = 1", "t = 3", "t = 0", "t = 1/3"],
    correct: "t = 0",
  },
  {
    questionText: "Solve: □ + 14 = 64",
    options: ["64 + 14", "14 − 64", "50 + 14", "64 − 50"],
    correct: "50",
  },

  // Geometry section
  {
    questionText: "What is the name of a 6-sided polygon?",
    options: ["Pentagon", "Hexagon", "Heptagon", "Octagon"],
    correct: "Hexagon",
  },
  {
    questionText: "Which shape has all sides equal and all angles equal?",
    options: ["Rectangle", "Parallelogram", "Rhombus", "Square"],
    correct: "Square",
  },
  {
    questionText: "How many degrees are in a triangle?",
    options: ["90°", "180°", "270°", "360°"],
    correct: "180°",
  },
  {
    questionText: "How many right angles are in a rectangle?",
    options: ["1", "2", "3", "4"],
    correct: "4",
  },
  {
    questionText: "Which figure has no lines of symmetry?",
    options: ["Square", "Circle", "Rectangle", "Scalene triangle"],
    correct: "Scalene triangle",
  },
  {
    questionText: "A triangle with all three sides equal is called:",
    options: ["Isosceles", "Scalene", "Equilateral", "Right-angled"],
    correct: "Equilateral",
  },
  {
    questionText: "What is the name of a polygon with 8 sides?",
    options: ["Hexagon", "Heptagon", "Octagon", "Nonagon"],
    correct: "Octagon",
  },
  {
    questionText: "What is the total of angles in a quadrilateral?",
    options: ["90°", "180°", "270°", "360°"],
    correct: "360°",
  },
  {
    questionText: "How many faces does a cube have?",
    options: ["4", "5", "6", "8"],
    correct: "6",
  },
  {
    questionText: "Which shape has curved surface only?",
    options: ["Cube", "Cylinder", "Cone", "Sphere"],
    correct: "Sphere",
  },
  {
    questionText: "Which 3D shape has a circular base and a pointed top?",
    options: ["Sphere", "Cone", "Cylinder", "Cube"],
    correct: "Cone",
  },
  {
    questionText: "What do we call the distance around a shape?",
    options: ["Area", "Volume", "Length", "Perimeter"],
    correct: "Perimeter",
  },
  {
    questionText: "Which angle is greater than 90° but less than 180°?",
    options: ["Right angle", "Acute angle", "Obtuse angle", "Reflex angle"],
    correct: "Obtuse angle",
  },
  {
    questionText: "A right angle equals how many degrees?",
    options: ["45°", "60°", "90°", "120°"],
    correct: "90°",
  },
  {
    questionText: "Which unit is used to measure angles?",
    options: ["cm", "litres", "grams", "degrees"],
    correct: "degrees",
  },
  {
    questionText: "A shape with 3 sides is called a:",
    options: ["Square", "Triangle", "Hexagon", "Polygon"],
    correct: "Triangle",
  },
  {
    questionText: "What is the name of a flat shape with 4 equal sides and 4 right angles?",
    options: ["Rectangle", "Trapezium", "Square", "Rhombus"],
    correct: "Square",
  },
  {
    questionText: "Which part of a circle passes through the center and touches both ends?",
    options: ["Radius", "Chord", "Diameter", "Arc"],
    correct: "Diameter",
  },
  {
    questionText: "What shape is the base of a cylinder?",
    options: ["Square", "Rectangle", "Triangle", "Circle"],
    correct: "Circle",
  },
];

export default function MathsQuiz8({ studentInfo, onComplete }) {
  return <Quiz studentInfo={studentInfo} questions={questions} onComplete={onComplete} />;
}
